"use strict";

var _toConsumableArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/defineProperty.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SensorSort = void 0;

var react_1 = __importDefault(require("react"));

var ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));

var hooks_1 = require("../../hooks");

var SensorSort = function SensorSort() {
  var flagsHook = (0, hooks_1.useFlags)();

  var _ref = (0, hooks_1.useReactifySearchContext)(),
      options = _ref.options,
      config = _ref.config;

  var _ref2 = (0, hooks_1.useCuration)(),
      curation = _ref2.curation;

  var _ref3 = (0, hooks_1.useSortBy)(),
      sortOption = _ref3.sortOption;

  var _react_1$default$useM = react_1.default.useMemo(function () {
    return {
      sort: buildSort({
        mode: options.mode,
        market: options.market,
        curation: curation,
        sortOption: sortOption,
        collectionHandle: options.mode === "collection" ? options.collectionHandle : undefined
      }),
      query: buildQuery({
        sortOption: sortOption,
        curation: curation
      })
    };
  }, [options, config, sortOption, curation]),
      sort = _react_1$default$useM.sort,
      query = _react_1$default$useM.query;

  if (!flagsHook.flags["reactify-search:flag_sensor_sort"]) {
    return null;
  }

  return react_1.default.createElement(ReactiveComponent_1.default, {
    componentId: "SensorSort",
    customQuery: function customQuery() {
      return {
        sort: sort,
        query: query
      };
    }
  });
};

exports.SensorSort = SensorSort;

var buildSort = function buildSort(args) {
  var mode = args.mode,
      curation = args.curation,
      sortOption = args.sortOption,
      collectionHandle = args.collectionHandle; // curation positions are only applied for the default `collections.position` or `_score` sort
  // if the sort is something else, apply a normal sort which applies what the user has requested

  if (mode !== "instant-search") {
    if (sortOption && !["_score", "collections.position"].includes(sortOption.field)) {
      return [_defineProperty({}, sortOption.field, sortOption.direction)];
    }
  }

  var sorts = []; // collection curation pin sorting

  if (mode === "collection" && collectionHandle) {
    if (curation === null || curation === void 0 ? void 0 : curation.collectionHandle) {
      var queries = [{
        term: {
          "curations.collectionHandle.keyword": curation.collectionHandle
        }
      }];

      if (args.market) {
        queries.push({
          term: {
            "curations.markets.keyword": args.market
          }
        });
      }

      sorts.push({
        "curations.position": {
          unmapped_type: "long",
          order: "asc",
          nested: {
            path: "curations",
            filter: {
              bool: {
                must: queries
              }
            }
          }
        }
      });
    }
  } // search curation pin sorting


  if (mode === "search" || mode === "instant-search") {
    if (curation === null || curation === void 0 ? void 0 : curation.searchTerm) {
      var _queries = [{
        term: {
          "curations.searchTerm.keyword": curation.searchTerm.toLowerCase()
        }
      }];

      if (args.market) {
        _queries.push({
          term: {
            "curations.markets.keyword": args.market
          }
        });
      }

      sorts.push({
        "curations.position": {
          unmapped_type: "long",
          order: "asc",
          nested: {
            path: "curations",
            filter: {
              bool: {
                must: _queries
              }
            }
          }
        }
      });
    }
  } // curation boost sorting


  if (curation) {
    if (0 < curation.boosting.groupings.length) {
      var groupings = curation.boosting.groupings.sort(function (a, b) {
        return a.position > b.position ? 1 : -1;
      });

      var _iterator = _createForOfIteratorHelper(groupings),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var grouping = _step.value;

          try {
            var query = JSON.parse(grouping.query);
            if (query) sorts.push(query);
          } catch (_a) {
            console.error("query could not be parsed for boost grouping", grouping);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (0 < curation.boosting.sortings.length) {
      var sortings = curation.boosting.sortings.sort(function (a, b) {
        return a.position > b.position ? 1 : -1;
      });

      var _iterator2 = _createForOfIteratorHelper(sortings),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var sorting = _step2.value;

          try {
            var _query = JSON.parse(sorting.query);

            if (_query) sorts.push(_query);
          } catch (_b) {
            console.error("query could not be parsed for boost sorting", sorting);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } // default collection sorting


  if (mode === "collection" && collectionHandle) {
    sorts.push.apply(sorts, _toConsumableArray(mapCollectionPositionSortClause(collectionHandle)));
  } // default search sorting


  if (mode === "search" || mode === "instant-search") {
    sorts.push("_score");
  }

  return sorts;
};
/**
 * Return a sort clause which sorts by position within the given collection.
 */


function mapCollectionPositionSortClause(collectionHandle) {
  return [{
    "collections.position": {
      order: "asc",
      nested: {
        path: "collections",
        filter: {
          term: {
            "collections.handle.keyword": collectionHandle
          }
        }
      }
    }
  }];
}

var buildQuery = function buildQuery(args) {
  var _a;

  var curation = args.curation,
      sortOption = args.sortOption;

  if (!curation || curation.id.includes("global")) {
    return undefined;
  }

  return {
    bool: {
      must_not: [{
        nested: {
          path: "curations",
          query: {
            bool: {
              must: [{
                term: _defineProperty({}, "curations.".concat("collection" === curation.type ? "collectionHandle" : "searchTerm", ".keyword"), "collection" === curation.type ? curation.collectionHandle : (_a = curation.searchTerm) === null || _a === void 0 ? void 0 : _a.toLowerCase())
              }, {
                term: {
                  "curations.hidden": true
                }
              }]
            }
          }
        }
      }].concat(_toConsumableArray(sortOption && !["_score", "collections.position"].includes(sortOption.field) ? [{
        term: {
          type: "callout"
        }
      }] : []))
    }
  };
};